import gql from 'graphql-tag';

export let FETCH_PROJECTS_QUERY = gql`
  query FetchProjectQuery {
    readAllProject {
      id
      name
      url
      client {
        email
        password
      }
    }
  }
`;
